import React from "react";
import clsx from "clsx";
import { twMerge } from "tailwind-merge";
import { useLocation } from "react-router-dom";
import { Anchor } from "@ht/components";
import ChevronDown from "@ht/shared/fonts/deos-pis/chevron-down";
import { Menu } from "../../../app/auth/types";

interface Props {
    menu: Menu[];
}

const SubMenu: React.FC<Props> = ({ menu }) => {
    return (
        <ul className="absolute top-full left-1/2 -translate-x-1/2 hidden z-10 group-hover:block">
            <div className="w-[448px] flex flex-wrap bg-white mt-5 px-4 py-2.5 shadow-lg rounded-lg">
                {menu.map((nav) => {
                    return (
                        <li
                            key={nav.id}
                            className="w-1/2 flex items-center justify-start p-2 gap-2.5"
                        ></li>
                    );
                })}
            </div>
        </ul>
    );
};

const MainMenu: React.FC<Props> = ({ menu }) => {
    const location = useLocation();

    return (
        <nav className="hidden mx-10 lg:block">
            <ul className="flex items-center gap-10 text-md">
                {menu?.map((nav) => {
                    const { submenu } = nav;
                    const hasChildren = submenu
                        ? submenu.filter(
                              (x) =>
                                  x.position === "TOP" || x.position === "BOTH"
                          ).length > 0
                        : false;

                    const active =
                        nav.url === "/"
                            ? location.pathname === nav.url
                            : location.pathname.includes(nav.url as string);

                    return (
                        <li
                            key={nav.id}
                            className={clsx("cursor-pointer", {
                                "flex items-center gap-1 relative group":
                                    hasChildren,
                            })}
                        >
                            <Anchor
                                className={twMerge(
                                    clsx(
                                        "text-primary-400 font-semibold text-md",
                                        {
                                            "text-white": active,
                                        }
                                    )
                                )}
                                path={nav.url as string}
                            >
                                {nav.label}
                            </Anchor>
                            {hasChildren && (
                                <>
                                    <ChevronDown className={clsx("w-3 h-2")} />
                                    {!!submenu && <SubMenu menu={submenu} />}
                                </>
                            )}
                        </li>
                    );
                })}
            </ul>
        </nav>
    );
};

export default MainMenu;
